const BANK_ID_RESPONSES = {
  FAILED: 'failed',
  NOT_FOUND: 'notFound',
  COMPLETED: 'completed',
  STARTED: 'started',
  CANCELED: 'canceled',
};

export default BANK_ID_RESPONSES;
